<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved. 
 Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="d-flex flex-row justify-content-start align-items-center">
  <button
    mat-icon-button
    ngxClipboard
    color="primary"
    [cbContent]="toTerraform()"
    (click)="$event.stopPropagation()"
    (cbOnSuccess)="onClipboardSuccess()"
    matTooltip="Copy Terraform"
  >
    <mat-icon class="mdi-18px" fontIcon="mdi-content-copy"></mat-icon>
  </button>
  <div matTooltip="{{ output.description }}">{{ output.name }}</div>
</div>
